/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2025. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

export default class PasswordPolicyModel {
  /**
   * Creates an instance of PasswordPolicyModel.
   * @class PasswordPolicyModel
   * @property {number} minLength - Minimum password length
   * @property {number} maxLength - Maximum password length
   * @property {boolean} requireUppercase - Require at least one uppercase letter
   * @property {boolean} requireLowercase - Require at least one lowercase letter
   * @property {boolean} requireNumbers - Require at least one number
   * @property {boolean} requireSpecialChars - Require at least one special character
   */
  constructor(data = {}) {
    this.minLength = data.minLength || 1;
    this.maxLength = data.maxLength || 100;
    this.requireUppercase = data.requireUppercase || false;
    this.requireLowercase = data.requireLowercase || false;
    this.requireNumbers = data.requireNumbers || false;
    this.requireSpecialChars = data.requireSpecialChars || false;
  }
}
